// This published page was verified empty on 23 October 2026.
// Keep its CMS record and direct route; suppress its navigation entry.
// Wholesale has a customer-state-dependent form and must remain reachable.
const emptyPaths = new Set(['/o-nas']);
const publicOrigin = 'https://autodiely-ke.sk';

export function isEmptyAutodielyNavigation(
  href: string | { pathname?: string | null; hostname?: string | null; host?: string | null; protocol?: string | null },
): boolean {
  const value = typeof href === 'string' ? href : href?.pathname;
  if (!value || (typeof href !== 'string' && (href.hostname || href.host || href.protocol))) return false;
  // Relative-to-current-page, query-only and fragment links retain their behavior.
  if (!value.startsWith('/') && !/^https?:\/\//i.test(value)) return false;
  try {
    const url = new URL(value, publicOrigin);
    if (url.origin !== publicOrigin) return false;
    const pathname = url.pathname.replace(/^\/sk(?=\/)/, '').replace(/\/+$/, '');
    return emptyPaths.has(pathname);
  } catch {
    return false;
  }
}
